module.exports = __webpack_public_path__ + "media/src/images/icons/eye/closed-0d518f563c17d55b945a7dc371a0298f.svg";